module.exports = __webpack_public_path__ + "static/media/SEJ_Logo_nuevo.525a4474.png";